<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>商户资料</span>
      </div>

      <el-form :model="ruleForm" :rules="rules" label-width="150px" style="width:80%;" ref="ruleForm" size="mini">
        <el-divider content-position="left">基本信息</el-divider>

        <el-row>
          <el-col :span="12">
            <el-form-item label="商户编号" prop="merchno">
              <el-input v-model="ruleForm.merchno" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户名称" prop="merchname">
              <el-input v-model="ruleForm.merchname" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="登录账号" prop="lbh">
              <el-input v-model="ruleForm.lbh" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户银行名称" prop="account">
              <el-input v-model="ruleForm.account"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="商户收款名称" prop="makename">
              <el-input v-model="ruleForm.makename"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款银行账号" prop="makeaccount">
              <el-input v-model="ruleForm.makeaccount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注" prop="bz">
          <el-input type="textarea" v-model="ruleForm.bz"></el-input>
        </el-form-item>
        <el-divider content-position="left">扩展信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="lxr">
              <el-input v-model="ruleForm.lxr"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="lxdh">
              <el-input v-model="ruleForm.lxdh"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="QQ" prop="qq">
              <el-input v-model="ruleForm.qq"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司网址" prop="website">
              <el-input v-model="ruleForm.website"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="营业执照" prop="busimage">
          <el-upload
            :file-list="fileList"
            :limit="1"
            accept=".jpg,.jpeg,.png"
            :action="`${this.$store.state.upBaseUrl}coupon-merch/merch/fileUpload`"
            :headers="myHeaders"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
            :on-exceed="handleExceed">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件，且不超过一个文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即保存</el-button>
        </el-form-item>

        <div v-if="ruleForm.major != 'true'">
          <el-divider content-position="left">支付配置信息</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收款商户号1(旧)" prop="wmerchantId">
                <el-input v-model="ruleForm.wmerchantId" :disabled="true">
                  <el-button slot="append" @click="handleSq('电银')" v-if="askstate == '0'">申请修改</el-button>
                  <el-button slot="append" v-if="askstate == '1'">已申请</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收款商户号2(新)" prop="ybmerchantno">
                <el-input v-model="ruleForm.ybmerchantno" :disabled="true">
                  <el-button slot="append" @click="handleSq('易宝')" v-if="askstate == '0'">申请修改</el-button>
                  <el-button slot="append" v-if="askstate == '1'">已申请</el-button>
                </el-input>
                <span style="color:red;font-size:12px;">*此商户号非该后台商户编号，此为收款所用，请联系工作人员获取并填写</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-table :data="data" size="mini">
              <el-table-column prop="createDate" label="申请日期"></el-table-column>
              <el-table-column prop="merchName" label="申请人"></el-table-column>
              <el-table-column prop="state" label="申请状态"></el-table-column>
              <el-table-column prop="auditDate" label="审核日期"></el-table-column>
            </el-table>
          </el-form-item>
        </div>


        <div v-if="ruleForm.major == 'true'">
          <el-divider content-position="left">分账商户号配置</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="分账接收商户号1(旧)" prop="saMchId">
                <el-input v-model="ruleForm.saMchId"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="分账接收商户号2(新)" prop="ybMchId">
                <el-input v-model="ruleForm.ybMchId"></el-input>
                <span style="color:red;font-size:12px;">*此商户号非该后台商户编号，此为分账所用，请联系工作人员获取并填写</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" @click="onSubmitSaMchId">立即保存</el-button>
          </el-form-item>
        </div>

      </el-form>
    </el-card>

    <!-- 修改电银商户号申请 -->
    <el-dialog title="申请" :visible.sync="dialogFormVisible" width="40%">
      <el-form :model="mchform" :rules="askRules" ref="askRuleForm" size="mini">
        <el-form-item label="申请类型" :label-width="formLabelWidth">
          <el-input v-model="mchform.merchType" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="申请主体" :label-width="formLabelWidth">
          <el-input v-model="mchform.merchName" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="商户号" :label-width="formLabelWidth" prop="merchantId">
          <el-input v-model="mchform.merchantId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="申请原因" :label-width="formLabelWidth" prop="desc">
          <el-input type="textarea" v-model="mchform.merdesc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRevise()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看图片 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import JsEncrypt from 'jsencrypt'
export default {
  data () {
    return {
      myHeaders:{},
      askstate:'0',
      data:[],
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      mchform:{},
      ruleForm: {
        id:'',
        merchno: '',
        merchname: '',
        bz: '',
        lbh: '',
        account: '',
        makename: '',
        makeaccount: '',
        website: '',
        qq: '',
        lxr: '',
        lxdh: '',
        busimage: '',
        zapppid: '',
        zprivateKey: '',
        zpublicKey: '',
        wmerchantId: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入用户账户', trigger: 'blur' }
        ],
        makename: [
          { required: true, message: '请输入收款名称', trigger: 'blur' }
        ],
        makeaccount: [
          { required: true, message: '请输入收款账户', trigger: 'blur' }
        ],
        zapppid: [
          { required: true, message: '请输入支付宝APPID', trigger: 'blur' }
        ],
        zprivateKey: [
          { required: true, message: '请输入支付宝私钥', trigger: 'blur' }
        ],
        zpublicKey: [
          { required: true, message: '请输入支付宝公钥', trigger: 'blur' }
        ],
        lxr: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        lxdh: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' }
        ],
        busimage: [
          { required: true, message: '请上传营业执照', trigger: 'blur' }
        ],
      },
      askRules: {
        merchantId: [
          { required: true, message: '电银商户号', trigger: 'blur' }
        ],
        merdesc: [
          { required: true, message: '请输入申请原因', trigger: 'blur' }
        ]
      }
    }
  },
  created(){
    var token =  window.sessionStorage.getItem('token');
    this.myHeaders = {'oa-token':token}
    this.getMerch();
  },
  methods: {
    handleRevise(){
      let _this = this;
      this.$refs.askRuleForm.validate((valid) => {
        if (valid) {
          _this.mchform.merchantId = _this.mchform.merchantId.trim();
          this.$ajax({
            url:"/coupon-merch/merch/addAsk",
            async:false,
            methods:'POST',
            data:_this.mchform,
            success:function(response){
              if (response == "SUCCESS") {
                _this.dialogFormVisible = false;
                _this.$message({message: '申请成功',type: 'success'});
              }else{
                _this.$message.error("申请失败");
              }
              _this.handleQueryAsk();
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          })
        } else {
          _this.$message.error('error submit!!');
          return false;
        }
      });
    },
    handleSq(type){
      this.mchform.merchName = this.ruleForm.merchname;
      this.mchform.merchNo = this.ruleForm.merchno;
      this.mchform.merchType = type;
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    onSubmit(){
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // if(this.fileList.length == 0){
          //   that.$message.error("请上传营业执照");
          //   return;
          // }
          this.$ajax({
            url:"/coupon-merch/merch/updMerch",
            async:false,
            methods:'POST',
            data:that.ruleForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.$message({message: '保存成功',type: 'success'});
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });
    },
    onSubmitYbMchId(){
      let that = this;
      this.$ajax({
        url:"/coupon-merch/merch/updMerchYbMchId",
        async:false,
        methods:'POST',
        data:that.ruleForm,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code==0) {
            that.$message({message: '保存成功',type: 'success'});
          }else{
            that.$message.error(response.message);
          }
        },
        error:function(){
          that.$message.error("请求失败");
        }
      })
    },
    onSubmitSaMchId(){
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if(that.ruleForm.ybMchId != null){
            that.ruleForm.ybMchId = that.ruleForm.ybMchId.trim();
          }
          if(that.ruleForm.saMchId != null){
            that.ruleForm.saMchId = that.ruleForm.saMchId.trim();
          }

          this.$ajax({
            url:"/coupon-merch/merch/updMerchSaMchId",
            async:false,
            methods:'POST',
            data:that.ruleForm,
            success:function(response){
              if (response.code==0) {
                that.$message({message: '保存成功',type: 'success'});
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });
    },
    getMerch(){
      let that = this;
      let id = this.$store.state.userInfo.id || window.sessionStorage.getItem('id');
      if(id != null){
        this.$ajax({
          url:"coupon-merch/merch/getMerchById",
          async:false,
          data:{'id':id},
          token:window.sessionStorage.getItem('token'),
          success:function(response){
            if (response.code==0) {
              that.ruleForm = response.data;
              if (response.data.busimage !="" && response.data.busimage != null) {
                that.fileList.push({'url':that.$store.state.imgBaseUrl+response.data.busimage});
              }
              that.handleQueryAsk();
            }else{
              that.$message.error(response.message);
            }
          },
          error:function(){
            that.$message.error("查询失败");
          }
        })
    	}
    },
    handleQueryAsk(){
      let _this = this;
      let merchno = this.ruleForm.merchno || '';
      this.$ajax({
        url:"/coupon-merch/merch/queryMerchAskByNo",
        async:false,
        methods:'POST',
        data:{'merchNo':merchno},
        success:function(response){
          if (response.code==0) {
            _this.data = response.data;
          }else{
            _this.$message.error(response.message);
          }
          _this.handleQueryAskCount();
        },
        error:function(){
          _this.$message.error("查询失败");
        }
      })
    },
    handleQueryAskCount(){
      let _this = this;
      let merchno = this.ruleForm.merchno || '';
      this.$ajax({
        url:"/coupon-merch/merch/queryMerchAskCountByNo",
        async:false,
        methods:'POST',
        data:{'merchNo':merchno},
        success:function(response){
          if (response.code==0) {
            _this.askstate = response.data;
          }else{
            _this.$message.error(response.message);
          }
        },
        error:function(){
          _this.$message.error("查询失败");
        }
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      if (res.code == 0) {
        this.ruleForm.busimage = res.data;
        this.dialogImageUrl = URL.createObjectURL(file.raw);
        this.dialogVisible = true;
      }

    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/merch/merchinfo.vue